import { render, staticRenderFns } from "./PreviewNotification.vue?vue&type=template&id=4452f997"
import script from "./PreviewNotification.vue?vue&type=script&lang=js"
export * from "./PreviewNotification.vue?vue&type=script&lang=js"
import style0 from "./PreviewNotification.vue?vue&type=style&index=0&id=4452f997&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports